export default __webpack_public_path__ + "static/media/icn-target.75b9a657.svg";